import Card, { CardHeader, CardTitle, CardBody } from './Card'
import Pill from './Pill'

export default function Context() {
  return (
    <section className="mt-8 mb-8" id="context" aria-label="Context">
      <Card>
        <CardHeader>
          <CardTitle>Context</CardTitle>
          <Pill>where this fits</Pill>
        </CardHeader>
        <CardBody>
          <p className="m-0 text-muted-dark leading-[1.7] max-w-[72ch]">
            I'm currently the Head of AI at ALKEME, where the work is focused on real-world systems, scale, and accountability.
            That role shapes how I think and gives me a lot of room to explore — but it also comes with real responsibility.
          </p>
          <p className="m-0 text-muted-dark leading-[1.7] max-w-[72ch] mt-3">
            This site is where I can hone my personal skills without creating risk or confusion for anyone else. It's a place to explore ideas, build rough models, and learn quickly outside of production environments.
            The goal isn't correctness — it's understanding.
          </p>
        </CardBody>
      </Card>
    </section>
  )
}

